import { createSlice } from '@reduxjs/toolkit';

import { AddToGroupStepType } from '~/enums/AddToGroupType';

import { getPersistedState } from '../../persist';
import { ColumnWidths, KeyMapToPersist, Modal, State } from './types';

const keysToPersist: (keyof State)[] = ['columnWidths'];
const keyMapToPersist: KeyMapToPersist = keysToPersist.reduce<KeyMapToPersist>(
  (prev, curr) => {
    prev[curr] = ['Document Group', curr];
    return prev;
  },
  {},
);
export const pathsToPersist = Object.values(keyMapToPersist);

export const initialState: State = {
  group: undefined,
  columnOrder: [],
  currentTableView: undefined,
  modal: undefined,
  tableViewSet: [],
  queryFields: undefined,
  currentAddToGroupStep: AddToGroupStepType.DOCUMENTS,
  documentIds: undefined,
  documentId: undefined,
  ...{
    columnWidths: getPersistedState(keyMapToPersist.columnWidths!, {}),
  },
};

export default createSlice({
  name: 'Document Group',
  initialState,
  selectors: {
    selectColumnOrder: (state) => state.columnOrder.map(String),
    selectColumnWidths: (state) => state.columnWidths,
    selectQueryFields: (state) => state.queryFields,
    selectModal: (state) => state.modal,
    selectDocumentIds: (state) => state.documentIds,
    selectDocumentId: (state) => state.documentId,
    currentAddToGroupStep: (state) => state.currentAddToGroupStep,
    currentTableView: (state) => state.currentTableView,
  },
  reducers: {
    initColumnOrder: (state, action) => {
      if (!state.columnOrder) {
        state.columnOrder = action.payload;
      }
    },
    setGroup: (state, action) => {
      state.group = action.payload;
    },
    setColumnOrder: (state, action) => {
      state.columnOrder = action.payload;
    },
    patchColumnWidths: (state, action: { payload: ColumnWidths }) => {
      state.columnWidths = {
        ...state.columnWidths,
        ...action.payload,
      };
    },
    setModal: (
      state,
      action: {
        payload: Modal | undefined;
      },
    ) => {
      state.modal = action.payload;
    },
    setTableViewSet: (state, action) => {
      state.tableViewSet = action.payload;
    },
    setCurrentTableView: (state, action) => {
      state.currentTableView = action.payload;
    },
    setQueryFields: (state, action) => {
      state.queryFields = action.payload;
    },
    setCurrentAddToGroupStep: (state, action) => {
      state.currentAddToGroupStep = action.payload;
    },
    setDocumentIds: (state, action) => {
      state.documentIds = action.payload;
    },
    setDocumentId: (state, action) => {
      state.documentId = action.payload;
    },
  },
});
